import React from 'react';
import styled from '@emotion/native';
import { BaseText, LoraText } from '@/shared/components/StyledText';
import { green, subheadline } from '@/shared/styles/colors';
import Checkbox from '@/shared/components/Checkbox';

interface PriceTierOptionProps {
  title: string;
  description?: string;
  isSelected: boolean;
  onPress: () => void;
}

const PriceTierOption: React.FC<PriceTierOptionProps> = ({
  title,
  description,
  isSelected,
  onPress,
}) => (
  <CheckBoxContaier isCentered={!Boolean(description)}>
    <Checkbox checked={isSelected} onPress={onPress} />
    <TextContainer>
      <TierText boldFont={isSelected}>{title}</TierText>
      {description && <DescriptionText>{description}</DescriptionText>}
    </TextContainer>
  </CheckBoxContaier>
);

const CheckBoxContaier = styled.View<{ isCentered: boolean }>(
  ({ isCentered }) => ({
    flexDirection: 'row',
    marginBottom: 26,
    alignItems: isCentered ? 'center' : 'flex-start',
  }),
);

const TextContainer = styled.View({
  marginLeft: 8,
  flex: 1,
});

const TierText = styled(LoraText)<{ boldFont: boolean }>(({ boldFont }) => ({
  letterSpacing: 2.4,
  fontSize: 15,
  color: green,
  marginBottom: 7,
  fontWeight: boldFont ? 'bold' : 500,
}));

const DescriptionText = styled(BaseText)({
  fontSize: 15,
  color: subheadline,
  letterSpacing: -0.15,
});

export default PriceTierOption;
